import { useState, useEffect } from "react";
import { useTheme } from "@/App";
import Sidebar from "./Sidebar";
import Header from "./Header";

const DashboardLayout = ({ children, title }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { theme } = useTheme();
  const isLight = theme === 'light';

  useEffect(() => {
    if (typeof window !== "undefined") {
      if (theme === "light") {
        document.documentElement.classList.add("light");
        document.documentElement.classList.remove("dark");
      } else {
        document.documentElement.classList.add("dark");
        document.documentElement.classList.remove("light");
      }
    }
    return () => {
      // Clean up when leaving dashboard layout
      document.documentElement.classList.add("dark");
      document.documentElement.classList.remove("light");
    };
  }, [theme]);

  return (
    <div className={`dashboard-root min-h-screen transition-colors duration-300 ${isLight ? 'light-mode bg-[#F1F5F9] text-[#0F172A]' : 'bg-[#050505] text-white'}`} data-testid="dashboard-layout">
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      
      <div className="md:ml-64 min-w-0">
        <Header
          onMenuClick={() => setSidebarOpen(true)}
          title={title}
        />
        
        <main className="p-3 sm:p-4 md:p-6 lg:p-8 min-w-0" data-testid="dashboard-main">
          {children}
        </main>
      </div>

      <div className="h-16 md:hidden" />
    </div>
  );
};

export default DashboardLayout;
